<template>
    <div class="MainContact">
         <header>
            <div class="top">
                <span></span>
                <span>电子合同</span>
                <span>...</span>
            </div>
        </header>

        <div class="main">
            <div class="mainScroll" id="mainList">
                <div class="trip">
                       <div class="title">
                            <span><img src="../assets/行程.png" alt="" /></span>
                            <span class="anpai">行程安排</span>
                            <div class="titleShowStore">
                                <span><img src="../assets/基础信息.png" alt="" /></span>
                                <span>行程有<span v-text="IsStoreLength"></span>个购物点</span>
                            </div>
                        </div>
                        <div class="swiper">
                            <div class="swiper-container">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide" v-for="(item, dayIndex) in line" :key="dayIndex">
                                <div class="item" v-if="dayIndex == 0">
                                    <span class="line"></span>
                                    <div class="iconfont icon-point"></div>
                                    <div class="con">
                                    </div>
                                    <div class="time">
                                    <span></span>
                                    <span>——</span>
                                    </div>
                                </div>

                                <div
                                    :class="{ item: true, black: i.Status == 0 ? true : false,IsSelectStore:i.IsStore=='1'?true:false }"
                                    v-for="(i, index) in item.router"
                                    :key="index+333"
                                >
                                    <span
                                    class="line"
                                    v-if="
                                        index != item.router.length - 1 ||
                                        dayIndex == line.length - 1
                                    "
                                    ></span>
                                    <div
                                    :class="{
                                        iconfont: true,
                                        'icon-point': true,
                                        blue: i.IsStore == '0' ? true : false,
                                        yellow:i.IsStore == '1' ? true : false,
                                    }"
                                    ></div>
                                    <div :class="{con:true, IsStore:i.IsStore=='1'?true:false }">
                                        <span v-text="i.Projects"></span>
                                    </div>
                                    <div :class="{time:true, IsStore:i.IsStore=='1'?true:false }">
                                        <span v-text="i.TimeSpan + '分钟'"></span>
                                    </div>
                                    <div :class="{PointType:true, IsStore:i.IsStore=='1'?true:false }">
                                        <span v-text="i.PointType"></span>
                                    </div>
                                </div>

                                <div class="item" v-if="dayIndex == line.length - 1">
                                    <div class="iconfont icon-point"></div>
                                    <div class="con">
                                    </div>
                                    <div class="time">
                                    <span></span>
                                    <span>——</span>
                                    </div>
                                </div>
                                </div>
                            </div>

                            <!-- 如果需要分页器 -->
                            <div class="swiper-pagination" slot="pagination"></div>
                            </div>
                        </div>
                </div>

                <div class="corp">
                    <div class="title">
                        <span><img src="../assets/基础.png" alt="" /></span>
                        <span>基础信息</span>
                    </div>
                    <div class="row">
                        <span>合同编号</span>
                        <div class="rowSpan">
                          <span v-text="order.ContractNo"></span>
                        </div>
                    </div>
                    <div class="row">
                        <span>成人</span>
                        <div class="rowSpan">
                          <span class="underline" v-text="order.AdultCount"></span>
                          <span>人 × </span>
                          <span class="underline" v-text="order.AdultPrice"></span>
                          <span>元/人</span>
                        </div>
                    </div>
                    <div class="row">
                        <span>儿童</span>
                        <div class="rowSpan">
                          <span class="underline" v-text="order.ChildrenCount"></span>
                          <span>人 × </span>
                          <span class="underline" v-text="order.ChildrenPrice"></span>
                          <span>元/人</span>
                        </div>
                    </div>
                    <div class="row">
                        <span>老年人</span>
                        <div class="rowSpan">
                          <span class="underline" v-text="order.ElderlyCount"></span>
                          <span>人 × </span>
                          <span class="underline" v-text="order.ElderlyPrice"></span>
                          <span>元/人</span>
                        </div>
                    </div>
                    <div class="row">
                        <span>旅游者总数</span>
                        <div class="rowSpan">
                          <span v-text="order.TotoalCount"></span>
                        </div>
                    </div>
                    <div class="row">
                        <span>总价</span>
                        <div class="rowSpan">
                          <span v-text="order.AllPrice"></span>
                        </div>
                    </div>
                    <div class="row">
                        <span>姓名</span>
                        <div class="rowSpan">
                          <span v-text="orderMain.Name"></span>
                        </div>
                    </div>
                    <div class="row">
                        <span>身份证号码</span>
                        <div class="rowSpan">
                          <span v-text="orderMain.IDNumber"></span>
                        </div>
                    </div>
                    <div class="row">
                        <span>旅行社名称</span>
                        <div class="rowSpan">
                          <span v-text="company.Name"></span>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="MainBottom" v-show="IsStoreLength>0"   >
            <el-checkbox v-model="checked">我已查看合同原文，并且知晓购物行程。</el-checkbox>
        </div>
        <div class="btnTwo">
            <div @click="LookContact">查看合同原文</div>
            <div @click="goSign">签字确认</div>
        </div>

        <!-- 提示购物点 -->
        <el-dialog
          title=""
          :visible.sync="pictureDialog"
          width="70%"
           :close-on-click-modal="false"
          center
          class="picture-dialog"
        >
            <div class="showRemindImage"></div>
            <div class="showRemindStore">
              <table class="table" border="0">
                <tr v-for="(item, index) in storeData" :key="index">
                  <td class="iconfont icon-point"></td>
                  <td>{{item.Projects}}</td>
                  <td>时长：{{item.TimeSpan}} 分钟</td>
                </tr>
              </table>

               <!-- 2021-12-03 勾选是否愿意去购物点 -->
              <!-- <div class="selectWill">
                <span>是否愿意参加购物安排：</span>
                <el-radio v-model="IsWill" label="1">愿意</el-radio>
                <el-radio v-model="IsWill" label="0">不愿意</el-radio>
              </div> -->

              <div class="Know" @click="closeDialogKnow">
                我知道了
              </div>
            </div>
            <div class="dialogCancel" @click="closeDialog"><span>x</span></div>
        </el-dialog>

        <!-- 中国公民国内旅游文明行为公约 -->
        <el-dialog
         title=""
          :visible.sync="tripDialog"
          width="70%"
           :close-on-click-modal="false"
          center
          class="picture-dialog"
        >
          <div class="tripAppointment">
            <div class="title">中国公民国内旅游文明行为公约</div>
            <div class="content">营造文明、和谐的旅游环境，关系到每位游客的切身利益。做文明游客是我们大家的义务，请遵守以下公约：</div>
            <div class="text">1、维护环境卫生。不随地吐痰和口香糖，不乱扔废弃物，不在禁烟场所吸烟。</div>
            <div class="text">2、遵守公共秩序。不喧哗吵闹，排队遵守秩序，不并行挡道，不在公众场所高声交谈。</div>
            <div class="text">3、保护生态环境。不踩踏绿地，不摘折花木和果实，不追捉、投打、乱喂动物。</div>
            <div class="text">4、保护文物古迹。不在文物古迹上涂刻，不攀爬触摸文物，拍照摄像遵守规定。</div>
            <div class="text">5、爱惜公共设施。不污损客房用品，不损坏公用设施，不贪占小便宜，节约用水用电，用餐不浪费。</div>
            <div class="text">6、尊重别人权利。不强行和外宾合影，不对着别人打喷嚏，不长期占用公共设施，尊重服务人员的劳动，尊重各民族宗教习俗。</div>
            <div class="text">7、讲究以礼待人。衣着整洁得体，不在公共场所袒胸赤膊；礼让老幼病残，礼让女士；不讲粗话。</div>
            <div class="text">8、提倡健康娱乐。抵制封建迷信活动，拒绝黄、赌、毒。</div>
            <div class="line"></div>
            <div class="btnClose"  @click="closeTripDialog">关闭</div>
          </div>
        </el-dialog>

    </div>
</template>
  
<script>
import Swiper from "swiper";
var mySwiper;
export default {
    data(){
        return{
            orderId:"",
            line: {},
            IsStoreLength:0,

            //含有购物点的数据信息
            storeData:[],
            company:{},
            order:{},
            orderMain:{},

            checked:false,
            pictureDialog:false,

            //判断是否打开过弹框
            flag:false,

            resolutionType:2,
            userId: "",
            CallBack:"",

            tripDialog:false,
            IsOPen:false,//是否打开过

            IsWill:"1",//是否愿意
        }
    },
    methods:{
        closeTripDialog(){
          this.tripDialog=false;
        },
        getUserId(orderId){
          var _self = this;
          if (orderId != "" && orderId != null) {
            _self.axios
              .get("/api/Abutment/Common/GetUserId?orderId=" + orderId)
              .then(res => {
                if (res.status == "success") {
                  _self.userId = res.data;
                } else {
                  _self.userId="";
                }
              })
              .catch(err => {});
          }
        },
        closeDialogKnow(){
            var _self=this;
            // if(_self.IsWill==""){
            //   _self.$messagebox({
            //     title: "提示",
            //     message: "请勾选是否愿意参加购物安排!"
            //   });
            //   return false;
            // }

            _self.flag=true;
            _self.pictureDialog=false; 
            if((_self.flag==false && _self.IsStoreLength==0) || (_self.flag==true && _self.IsStoreLength>0)){
                if(_self.tripDialog==false && _self.IsOPen==true){
                   sessionStorage.setItem(
                    "Vue_newResolutionType",
                      _self.resolutionType
                    );
                  sessionStorage.setItem("Vue_newOrderId", _self.orderId);
                  sessionStorage.setItem("Vue_UserId", _self.userId);
                  sessionStorage.setItem("Vue_CallBack", _self.CallBack);
                  sessionStorage.setItem("Vue_IsWill", _self.IsWill);
                  _self.$router.push({
                    name: "NewSignature",
                    params: {
                      orderId: _self.orderId,
                      resolutionType: _self.resolutionType,
                      userId: _self.userId,
                      CallBack:_self.CallBack,
                      IsWill:_self.IsWill,
                    }
                  });
                  _self.IsOPen=false;
                }
                else{
                  _self.tripDialog=true;
                  _self.IsOPen=true;//打开
                }
            }
        },
        closeDialog(){
          var _self=this;
          if(_self.IsWill!=""){
            _self.flag=true;
            _self.tripDialog=false;
          }
          _self.pictureDialog=false; 
        },
        //查看合同
        LookContact(){
          var _self=this;
          _self.$router.push({
              name: "NewMainContact",  
              params: {
                orderId: _self.orderId
              }
          });
        },
        //确认签字
        goSign(){
          var _self=this;
          if(_self.checked==false && _self.IsStoreLength>0){
              _self
                  .$messagebox({
                  title: "提示",
                  message: "请先勾选‘我已查看合同原文，并且知晓购物行程’!",
                  showCancelButton: true,
                  closeOnClickModal: false
                  })
                  .then(r => {
                  if (r == "confirm") {
                      
                  }
              });
          }
          else{
              if((_self.flag==false && _self.IsStoreLength==0) || (_self.flag==true && _self.IsStoreLength>0)){
                if(_self.tripDialog==false && _self.IsOPen==true){
                    sessionStorage.setItem(
                    "Vue_newResolutionType",
                    _self.resolutionType
                  );
                  sessionStorage.setItem("Vue_newOrderId", _self.orderId);
                  sessionStorage.setItem("Vue_UserId", _self.userId);
                  sessionStorage.setItem("Vue_CallBack", _self.CallBack);
                  sessionStorage.setItem("Vue_IsWill", _self.IsWill);
                  _self.$router.push({
                    name: "NewSignature",
                    params: {
                      orderId: _self.orderId,
                      resolutionType: _self.resolutionType,
                      userId: _self.userId,
                      CallBack:_self.CallBack,
                      IsWill:_self.IsWill,
                    }
                  });
                }
                else{
                  _self.tripDialog=true;
                  _self.IsOPen=true;//打开
                }
              }
              else{
                _self.pictureDialog=true; 
                _self.IsWill="";
              }
          }
        },
        GetWeek(obj) {
          let _self = this;
          return _self.$root.GetWeekDay(obj);
        },
        GetData() {
          let _self = this;
          let param = {
              Id: _self.orderId
          };
          _self.axios
              .post("/api/Abutment/Common/GetContractContent", param)
              .then(res => {
              _self.line = res.data.router;
              _self.IsStoreLength=res.data.IsStore.length;
              _self.company=res.data.company;
              _self.order=res.data.order;
              _self.orderMain=res.data.orderMain;
              _self.storeData=res.data.IsStore;

          })
          .catch(err => {});
        }
    },
    mounted() {
        let _self = this;
        if (_self.$route.params.CallBack == null && _self.$route.query.CallBack == null)
        {
            _self.CallBack="";
        }
        else{
            _self.CallBack =
                _self.$route.params.CallBack != null
                ? _self.$route.params.CallBack
                : _self.$route.params.CallBack != null
                ? _self.$route.query.CallBack
                : _self.$route.query.CallBack;
        }

        if ( _self.$route.params.orderId == null && _self.$route.query.orderId == null) 
        {
            _self.$router.push("/HomePage");
        } 
        else {
            _self.orderId =
                _self.$route.params.orderId != null
                ? _self.$route.params.orderId
                : _self.$route.params.orderId != null
                ? _self.$route.query.orderId
                : _self.$route.query.orderId;
            
            _self.GetData();
            _self.getUserId(_self.orderId);
        }

        if(_self.$route.query.resolutionType==null && _self.$route.query.resolutionType==undefined && _self.$route.params.resolutionType == null)
        {
          _self.resolutionType=2;
        }
        else{
           _self.resolutionType =
                _self.$route.params.resolutionType != null
                ? _self.$route.params.resolutionType
                : _self.$route.params.resolutionType != null
                ? _self.$route.query.resolutionType
                : _self.$route.query.resolutionType;
        }

        mySwiper = new Swiper(".swiper-container", {
            direction: "horizontal", // 垂直切换选项
            loop: false, // 循环模式选项
            observer: true, //修改swiper自己或子元素时，自动初始化swiper
            observeParents: true, //修改swiper的父元素时，自动初始化swiper
            // 如果需要分页器
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },
            on: {
                slideChange: function() {
                    
                }
            }
        });
    },
    watch:{
      "checked":function(value){
        if(value==false){
          this.flag=false;
        }
      }
    },
}
</script>

<style>
.mint-msgbox{
  z-index: 999999999 !important;
}
.mint-msgbox-wrapper{
   z-index: 999999999 !important;
}
</style>

<style lang="less" scoped>
.selectWill{
  width: 93%;
  text-align: center;
  position: absolute;
  bottom: 275px;
  font-size: 23px;
  color: #333333;
}
.tripAppointment{
    width: 650px;
    background-color: #ffffff;
    margin-left: 49px;
    margin-top: -24px;
    margin-bottom: 35px;
    font-size: 28px;
    padding-bottom: 20px;
}
.tripAppointment .title{
  text-align: center;
  padding: 25px 0px;
  font-weight: bold;
  font-size: 40px;
}
.tripAppointment .content{
 padding: 10px;
 text-indent: 2rem;
 color: #333;
}
.tripAppointment .text{
  padding: 10px;
  text-indent: 2rem;
  color: #333;
}
.tripAppointment .line{
  border-bottom: 1px solid #ccc;
  padding: 10px 0px;
}
.tripAppointment .btnClose{
  width: 160px;
  height: 89px;
  margin-top: 20px;
  line-height: 89px;
  text-align: center;
  background-color: #01AE66;
  border-radius: 5px;
  font-size: 30px;
  color: #ffffff;
  position: relative;
    left: 422px;
}
 .underline {
    padding: 0px 15px !important;
    border-bottom: 2px solid black;
    height: 30px;
    line-height: 30px;
    word-break: break-all;
    box-sizing: border-box;
  }

.table{
  width: 100%;
  font-size: 23px;
  color: #333333;
}
.table .iconfont{
  font-size: 36px;
  color: #ffb21c !important;
}
.table tr td{
  padding-bottom: 10px;
  padding-top: 10px;
  letter-spacing: 1px;
}
.showRemindStore .Know{
  width: 559px;
  height: 77px;
  line-height: 77px;
	background-color: #a9e53e;
  border-radius: 45px;
  letter-spacing: 2px;
  color: #ffffff;
  font-size: 30px;
  text-align: center;
  position: absolute;
  bottom: 175px;
  left: 95px;
}

.dialogCancel{
    margin-top: 62px;
    color: #ffffff;
    font-size: 31px;
    border: 2px solid #ffffff;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    margin-left: 348px;
}
.dialogCancel span{
    padding: 16px;
}

.showRemindImage{
    width: 653px;
    height: 300px;
    background-image: url("../assets/图层1.png");
    background-repeat: no-repeat;
    margin-left: 49px;
}
.showRemindStore{
    width: 650px;
    background-color: #ffffff;
    margin-left: 49px;
    margin-top: -24px;
    padding-bottom: 310px;
}

.MainBottom{
    width: 100%;
    background-color: #ffefdb !important;
    font-size: 29px;
    font-weight: bold;
    color: #daa934 !important;
    padding: 30px 10px;
}
.btnTwo{
    width: 100%;
    height: 100px;
    background-color: #ffffff;
    display: flex;
}
.btnTwo div:first-child{
    color: #58afec;
    font-size: 30px;
    text-align: center;
    margin-top: 30px;
    margin-left: 81px;
}
.btnTwo div:last-child{
    flex: 1;
    height: 89px;
    line-height: 89px;
    text-align: center;
	background-color: #58afec;
    border-radius: 5px;
    font-size: 30px;
    color: #ffffff;
    margin-left: 131px;
    margin-top: 5px;
}

.IsSelectStore{
    background-color: #fff4df  !important;
}
.IsStore{
    color: #f5a915 !important;
}

.MainContact{
    width: 100%;
    min-height: 100%;
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-color: #ddd;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    header {
    padding: 20px;
    box-sizing: border-box;
    background-color: #ffffff;
    width: 100%;
    display: flex;
    flex-direction: column;
    color: black;

    .top {
      width: 100%;
      display: flex;
      align-items: center;
      letter-spacing: 2px;
      span:nth-of-type(1) {
        font-size: 34px !important;
        flex: 1;
        margin-right: 10px;
      }
      span:nth-of-type(2) {
        font-size: 30px !important;
        margin-right: 5px;
        flex: 1;
      }
      span:nth-of-type(3) {
        font-size: 52px !important;
        margin-top: -29px;
        font-weight: bold;
      }
    
    }

    .center {
      margin-top: 30px;
      width: 100%;
      display: flex;
      box-sizing: border-box;
      flex-wrap: wrap;

      span:nth-of-type(1) {
        width: 100%;
        font-size: 36px;
        font-weight: bold;
        letter-spacing: 3px;
        margin-bottom: 15px;
      }

      span:nth-of-type(n + 2) {
        width: 50%;
        font-size: 24px;
        letter-spacing: 2px;
      }

      span:nth-of-type(n + 4) {
        margin-top: 20px;
      }
    }

    .bottom {
      margin-top: 30px;
      display: flex;
      padding: 15px 20px;
      background-color: #ffffff;
      border-radius: 10px;
      box-shadow: 0px 0px 9px 1px rgba(0, 0, 0, 0.35);
      box-sizing: border-box;

      div:nth-of-type(1) {
        flex: 1;
        margin-right: 25px;
        font-size: 24px;
        letter-spacing: 2px;
        color: #666666;
      }

      div:nth-of-type(2) {
        background-color: #167fef;
        border-radius: 10px;
        font-size: 24px;
        letter-spacing: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 150px;
        a,
        a:link,
        a:visited,
        a:hover,
        a:active {
          color: white !important;
        }
      }
    }
    }

    .main {
    flex: 1;
    width: 100%;
    height: 100%;
    position: relative;
    .mainScroll {
      padding: 7px 6px;
      box-sizing: border-box;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      overflow-y: auto;

      .trip,
      .contact,
      .corp,
      .car,
      .guide {
        margin-bottom: 16px;
        background-color: #ffffff;
        box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.35);
        padding: 20px;
        box-sizing: border-box;

        .title {
          border-bottom: 1px solid #ddd;
          padding-bottom: 25px;
          box-sizing: border-box;
          display: flex;
          align-items: center;

          .titleShowStore{
            width: 250px;
            height: 54px;
            line-height: 54px;
            background-color: #f5a915 !important;
            border-radius: 27px;
          }
          .titleShowStore span{
            font-size: 20px !important;
            color: #ffffff !important;
             font-size: 34px;
            letter-spacing: 3px;
          }
          .titleShowStore span img{
              vertical-align: middle;
              margin-left: 18px;
          }
        }

        .row {
          padding: 10px 0;
          border-bottom: 1px solid #ddd;
          margin-top: 10px;
          
          letter-spacing: 3px;
          
          span:first-child{
            font-size: 24px;
            color: #999999;
          }
          .rowSpan {
            font-size: 21px;
            color: #465865;
            position: absolute;
            right: 37px;
            margin-top: -30px;
          }
        }
      }

      .trip {
        .title {
          span:nth-of-type(1) {
            font-size: 34px;
            margin-right: 5px;
            color: #35b0fd;
          }
          .anpai{
             font-size: 34px;
            font-weight: bold;
            letter-spacing: 3px;
            line-height: 34px;
            color: #465865;
            flex: 1;
          }
        }

        .calendar {
          padding: 20px 0;
          width: 100%;
          overflow-x: scroll;
          display: flex;
          flex-wrap: nowrap;

          .item {
            width: 100px;
            flex-shrink: 0;
            display: flex;
            flex-direction: column;
            margin: 0 5px;
            justify-content: center;
            align-items: center;

            .week {
              font-size: 30px;
              letter-spacing: 2px;
              color: #6e7d88;
            }
            .date {
              display: flex;
              justify-content: center;
              align-items: center;
              margin-top: 10px;
              width: 90px;
              height: 90px;
              font-size: 40px;
              letter-spacing: 3px;
              color: #999999;
              border-radius: 100%;
              box-sizing: border-box;
              position: relative;

              .iconfont {
                position: absolute;
                bottom: 0;
                font-size: 24px;
              }
            }

            .tripDate {
              color: #35b0fd !important;
            }

            .active {
              background-color: #35b0fd;
              color: #ffffff !important;

              .iconfont {
                color: #35b0fd !important;
              }
            }
          }
        }

        .swiper {
          margin-top: 10px;
          .swiper-container {
            height: 100%;
            width: 100%;

            .swiper-slide {
              height: 100%;
              margin-bottom: 5vh;
              .blue {
                color: #27aa12  !important;
              }
              .yellow{
                   color: #ffb21c  !important;
              }

              .black {
                color: #465865 !important;
              }
            

              .item {
                display: flex;
                align-items: stretch;
                height: 80px;
                line-height: 80px;
                box-sizing: border-box;
                position: relative;
                color: #999999;

                .line {
                  position: absolute;
                  top: 25px;
                  left: 22px;
                  width: 1px;
                  height: 130%;
                  border-right: 3px solid #ddd;
                  z-index: 99;
                }

                .iconfont {
                  font-size: 50px !important;
                  display: flex;
                  align-items: flex-start;
                  margin-right: 20px;
                  line-height: 50px;
                  z-index: 999;
                }
                .con {
                  flex: 1;
                  margin-right: 20px;
                  display: flex;
                  flex-direction: column;

                  span:nth-of-type(1) {
                    font-size: 21px;
                    letter-spacing: 2px;
                  }
                }
                .time {
                  font-size: 21px;
                  letter-spacing: 2px;
                  color: #6e7d88;
                  position: absolute;
                  left: 456px;
                }
                .PointType{
                    margin-right: 10px;
                    font-size: 21px;
                    letter-spacing: 2px;
                    color: #6e7d88;
                    display: flex;
                    flex-direction: column;
                }
              }
            }
          }
        }
      }

      .contact {
        .title {
          span:nth-of-type(1) {
            font-size: 34px;
            margin-right: 5px;
            color: #ffb22b;
          }
          span:nth-of-type(2) {
            font-size: 34px;
            font-weight: bold;
            letter-spacing: 3px;
            line-height: 34px;
            color: #465865;
            flex: 1;
          }

          span:nth-of-type(3) {
            font-size: 24px;
            color: #465865;
          }
        }
      }
      .corp {
        .title {
          span:nth-of-type(1) {
            font-size: 34px;
            margin-right: 5px;
            color: #167fef;
          }
          span:nth-of-type(2) {
            font-size: 34px;
            font-weight: bold;
            letter-spacing: 3px;
            line-height: 34px;
            color: #465865;
            flex: 1;
          }
        }
      }
    }
    }
}



</style>


// WEBPACK FOOTER //
// src/components/NewContact.vue